import React, {useEffect, useState} from "react";
import Button from "@material-ui/core/Button";
import {ArrowBackIos} from "@material-ui/icons";
import {useNavigate, useParams} from "react-router-dom";
import {useTranslation} from "react-i18next";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import {run, useQuery} from "../utils/function-util";
import {getMachineTags, updateMachineTags} from "../api/machine-functions";
import {httpGet, httpPost} from "../api/http-functions";
import * as _ from 'lodash';
import {MachineAddNewTagForm} from "../components/machines/shared/machine-tags/MachineAddNewTagForm";
import {Breadcrumbs, Card, CardContent, CardHeader, CircularProgress} from "@material-ui/core";
import {makeStyles} from "@material-ui/core/styles";
import {MachineTagList} from "../components/machines/shared/machine-tags/MachineTagList";
import {Tag} from "../models/machine.models";

const useStyles = makeStyles(theme => ({
    root: {
        marginTop: '15px',
        marginBottom: '15px'
    },
    goBack: {
        margin: '15px'
    },
    content: {
        margin: '15px'
    },
    overlay: {
        zIndex: 99,
        width: '100%',
        height: '100%',
        position: 'absolute',
        top: 0,
        left: 0,
        background: "#00000050"
    },
    spinner: {
        position: 'relative', top: '50%', left: '50%'
    }
}));
export const MachineTagManagementView = (props: any) => {
    const navigate = useNavigate();
    const classes = useStyles();
    const {t} = useTranslation();
    const query = useQuery();
    const {organizationUnitId, machineId} = useParams<{ organizationUnitId: string, machineId: string }>();
    const customerId = query.get('customerId');
    const machineName = query.get('machineName');
    const [loading, setLoading] = useState(false);
    const [tagId, setTagId] = useState<any>(null);
    const [tags, setTags] = useState<any[]>([]);

    const goBack = () => {
        navigate(`/organization-units/${organizationUnitId}/detail?tab=1`);
    };

    const handleTagUpdate = (tagsToUpdate: Tag[]) => {
        const update = updateMachineTags(httpPost);
        return update({
            organizationUnitId: parseInt(organizationUnitId as string),
            machineId: (machineId as string),
            tagId,
            tags: tagsToUpdate
        });
    };

    const handleNewTagAdd = async (tag: any) => {
        setLoading(true);
        const newTags = [...tags, tag];
        await handleTagUpdate(newTags);
        setTags(newTags);
        setLoading(false);
    };
    const handleTagDelete = async (key: any) => {
        setLoading(true);
        const newTags = tags.filter(tag => tag.key !== key);
        await handleTagUpdate(newTags);
        setTags(newTags);
        setLoading(false);
    };
    const loadData = () => {
        setLoading(true);
        return getMachineTags(httpGet)({
            machineId: machineId as string,
            organizationUnitId: parseInt(organizationUnitId as string)
        });
    };
    useEffect(run(loadData, (result: any) => {
        setLoading(true);
        setTagId(_.get(_.keys(result), 0, null));
        setTags(_.flatten(_.values(result)));
        setLoading(false);
    }, undefined, () => setLoading(false)), [machineId, tagId, customerId]);

    return (<Grid container direction="column" alignItems="stretch" className={classes.root}>
            <Grid item={true} container direction="row" alignItems="center">
                <Button onClick={goBack} className={classes.goBack}>
                    <ArrowBackIos color="primary"/>
                </Button>
                <Breadcrumbs>
                    <Typography color="textPrimary" variant="body1">{machineName}</Typography>
                </Breadcrumbs>
            </Grid>
        <Card className={classes.content}>
            <CardHeader title={t('Machine.Actions.ManageTags')}/>

            <CardContent>
                <Grid container direction="column" justify="flex-end" alignItems="stretch">
                    <MachineAddNewTagForm handleNewTagAdd={handleNewTagAdd}/>

                    <MachineTagList tags={tags} handleDelete={handleTagDelete}/>
                </Grid>
                <div hidden={!loading} className={classes.overlay}>
                    <CircularProgress className={classes.spinner}/>
                </div>
            </CardContent>
        </Card>
    </Grid>);
};
